import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, {useState} from "react";

const headers = [
  {
    key: "present_name",
    name: "Gift Name",
  },
  {
    key: "stock",
    name: "Stock",
  },
  {
    key: "status",
    name: "Status",
  },
];

const GiftList = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const [searchValue, setSearchValue] = useState("");
  // const handleSearch = (value) => {
  //   console.log("searching value: ", value);
  // };

   const handleSearch = (value) => {
    //console.log("searching value: ", value);
    const trimmed = value.trim();
    if(trimmed.length > 0){
      setSearchValue(trimmed);
      setQuery({
        search: trimmed,
      });
    }else{
        setQuery({
      
    });
    }
  };

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/present",
    defaultQuery: "status=ACTIVE",
  });

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Gift List"
      data={data}
      headers={headers}
      idKey="present_id"
      endPoint="/present"
      setCurrentPage={setCurrentPage}
      removeDetails={true}
      hasSearch
      hasCreate
      hasActions
      module="Loyalty"
      subModule="Gift List"
      createPath={`/loyalty/gift/list/create`}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      disabledSerial
      reload={reload}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
      setQuery={setQuery}
    />
  );
};

export default GiftList;
